import Img3Component from './Img3Component';
export default Img3Component;



//////////////////
// WEBPACK FOOTER
// ./src/components/img3/index.ts
// module id = 922
// module chunks = 0 1 2 3 4 5 6 7